import { render } from "./ResultRankingSwiss.vue?vue&type=template&id=31c82e20&scoped=true"
import script from "./ResultRankingSwiss.vue?vue&type=script&lang=js"
export * from "./ResultRankingSwiss.vue?vue&type=script&lang=js"

import "./ResultRankingSwiss.vue?vue&type=style&index=0&id=31c82e20&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31c82e20"]])

export default __exports__